/* Haye Nii gold dial look for the PopSpin "Spin to win" popup (task 16c). Look: assets/hayenii-spin-skin.css
   PopSpin still does everything that matters: when it shows, the sign-up, the prize, the code, the timer.
   This file only dresses its popup: it draws the gold dial on top of PopSpin's own wheel (so the dial turns
   when PopSpin turns it and stops on the prize PopSpin picked), changes the words, and adds the light effects.
   Safety: if PopSpin's popup ever looks different from what we expect, or our CSS can't load, we change
   nothing and PopSpin's normal popup shows. Sign-ups never depend on this file. */
(function () {
  'use strict';
  const me = document.currentScript;
  const CSS_URL = me && me.dataset.css;
  const LOGO_URL = me && me.dataset.logo; // our logo on a pure white disc (PopSpin's copy has a grey square)
  const FONT_URL = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;1,500&display=swap';
  if (!CSS_URL || !window.customElements || !window.MutationObserver) return;

  const NS = 'http://www.w3.org/2000/svg';
  const C = 190, R_IN = 112, R_OUT = 166, R_LAB = 139, R_TICK = 178; // dial drawing units (380 x 380)
  const TEXT = {
    title: ['A gift for your ', 'first order'],
    sub: 'Every piece is handmade. Join us and reveal your welcome gift.',
    button: 'Reveal my gift',
    name: 'Your first name',
    email: 'Your email',
    fine: 'You’ll get emails from Haye Nii. Unsubscribe any time.'
  };
  const store = {
    get: k => { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  const easeOut = t => 1 - Math.pow(1 - t, 3);
  const pt = (r, deg) => { const a = (deg - 90) * Math.PI / 180; return [C + r * Math.cos(a), C + r * Math.sin(a)]; };
  const svg = (tag, attrs, parent) => {
    const e = document.createElementNS(NS, tag);
    for (const k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  };
  const div = (cls, parent) => { const d = document.createElement('div'); d.className = cls; if (parent) parent.appendChild(d); return d; };
  const anim = (ms, step, done) => {
    const t0 = performance.now();
    (function fr(now) { const t = Math.min(1, (now - t0) / ms); step(t); if (t < 1) requestAnimationFrame(fr); else if (done) done(); })(t0);
  };
  // angle (deg) of an element's own transform: rotate(x) only, as PopSpin sets it
  const angleOf = el => {
    const m = getComputedStyle(el).transform;
    if (!m || m === 'none') return 0;
    const v = m.split('(')[1].split(')')[0].split(',').map(parseFloat);
    return Math.atan2(v[1], v[0]) * 180 / Math.PI;
  };
  const near = d => { d = ((d % 360) + 540) % 360 - 180; return Math.abs(d); };
  // same test as the phone @media in the CSS: narrow, but not a phone held sideways (short + wide)
  const isPhone = () => window.matchMedia('screen and (max-width: 768px) and (min-height: 481px), screen and (max-width: 768px) and (max-aspect-ratio: 4/3)').matches;
  const visible = el => !!el && !el.hidden && el.style.display !== 'none';
  // "reduce motion" turned on in the phone/computer settings: no comet, sparks, flare or shine (PopSpin also spins shorter)
  const touch = () => !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  const calm = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // which dressed popups are open now: the chat bubble stays hidden while ANY of them is open
  // (one popup closing or being removed must not show the bubble over another one that is open)
  const openHosts = new Set();
  function markOpen(host, on) {
    if (on) openHosts.add(host); else openHosts.delete(host);
    document.documentElement.classList.toggle('hn-ps-open', openHosts.size > 0);
  }

  let fontAsked = false;
  function askFont() {
    if (fontAsked) return; fontAsked = true;
    const l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = FONT_URL;
    document.head.appendChild(l);
  }

  function dress(host) {
    if (host.__hnSkin) return;
    const root = host.shadowRoot;
    if (!root) return;
    const q = s => root.querySelector(s);
    const overlay = q('.ca-sw-modal-overlay'), card = q('.ca-sw-modal-content--wrapper'), content = q('.ca-sw-modal-content');
    const dial = q('.ca-sw-ui-wheel-of-fortune--classic'), list = dial && dial.querySelector('ul');
    const items = list ? Array.prototype.slice.call(list.querySelectorAll(':scope > li')) : [];
    const medal = dial && dial.querySelector('.ca-sw-center-dot');
    const form = q('#emailForm'), intro = q('.ca-sw-initial-content'), result = q('.ca-sw-result-container');
    const success = q('.ca-sw-result-success'), stage = q('.ca-sw-wheel-wrapper');
    const names = items.map(li => (li.textContent || '').replace(/\s+/g, ' ').trim());
    // Only dress the popup we know. Anything else: leave PopSpin exactly as it is.
    if (!overlay || !card || !content || !dial || !list || !medal || !form || !intro || !result || !success || !stage ||
        items.length < 2 || items.length > 12 || names.some(n => !n)) return;
    host.__hnSkin = true;

    // Our extra pieces stay hidden until our CSS is in. If it never loads, PopSpin looks like before.
    const guard = document.createElement('style');
    guard.textContent = ':host(:not(.hn-ps)) .hn-ps-x{display:none!important}:host(.hn-ps-wait) .ca-sw-modal-content--wrapper{opacity:0!important}';
    root.appendChild(guard);
    // popup already on screen before this file ran (slow page): never blank it; switch to our look only if the
    // shopper has not started yet (nothing typed, no spin), otherwise keep PopSpin's look for this view
    const lateStart = overlay.classList.contains('visible');
    if (!lateStart) host.classList.add('hn-ps-wait');
    let gaveUp = false;
    const link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = CSS_URL;
    link.onload = () => {
      host.classList.remove('hn-ps-wait');
      const busy = () => [].some.call(form.querySelectorAll('input[type="email"], input[type="text"], input[type="tel"], input:not([type])'), i => i.value) ||
        visible(result) || /\d+ms/.test(list.style.transition || '');
      if ((gaveUp || (lateStart && busy())) && visible(overlay) && overlay.classList.contains('visible')) return; // already in use with the old look: don't switch mid-view
      host.classList.add('hn-ps');
      onOpen();
    };
    link.onerror = () => { gaveUp = true; host.classList.remove('hn-ps-wait'); };
    root.appendChild(link);
    setTimeout(() => { if (!host.classList.contains('hn-ps')) { gaveUp = true; host.classList.remove('hn-ps-wait'); } }, 4000);
    askFont();

    // ---- words (PopSpin keeps the same fields and button, we only change what they say)
    const title = intro.querySelector('.ca-sw-modal-title'), sub = intro.querySelector('.ca-sw-modal-text');
    const btn = form.querySelector('.ca-sw-modal-spin-btn'), nameIn = q('#nameInput'), emailIn = q('#emailInput');
    const fine = form.querySelector('.ca-sw-email-info');
    if (title) { title.textContent = TEXT.title[0]; const em = document.createElement('em'); em.textContent = TEXT.title[1]; title.appendChild(em); }
    if (sub) sub.textContent = TEXT.sub;
    if (btn && !btn.querySelector('.ca-sw-spinner')) btn.textContent = TEXT.button;
    if (nameIn) { nameIn.placeholder = TEXT.name; nameIn.autocomplete = 'given-name'; nameIn.setAttribute('aria-label', TEXT.name); }
    if (emailIn) { emailIn.placeholder = TEXT.email; emailIn.autocomplete = 'email'; emailIn.setAttribute('autocapitalize', 'off'); emailIn.spellcheck = false; emailIn.setAttribute('aria-label', TEXT.email); }
    if (fine) fine.textContent = TEXT.fine;
    const kicker = div('hn-ps-x hn-ps-kicker');
    kicker.textContent = 'Welcome to Haye Nii';
    if (title && title.parentNode) title.parentNode.insertBefore(kicker, title);
    const closeBtn = q('.ca-sw-close-button');

    // remember the first name typed, for "Priya, your gift is unlocked"
    form.addEventListener('submit', () => {
      const raw = nameIn ? nameIn.value.trim().split(/\s+/)[0] || '' : '';
      const first = raw.slice(0, 20);
      store.set('hn_ps_name', first ? first.charAt(0).toUpperCase() + first.slice(1) : '');
    }, true);

    // ---- the gold dial: fixed bezel with watch ticks, a band of prize names that turns with PopSpin's wheel
    const N = items.length, step = 360 / N;
    // PopSpin puts prize i (0 = first) at the 9 o'clock side of its wheel and stops the winner at 3 o'clock.
    // We turn the wheel a quarter left with CSS, so the winner stops at 12 o'clock under our pointer.
    const homeAngle = i => 270 + i * step; // where prize i sits on the band (0 = top, clockwise)

    const bezel = svg('svg', { class: 'hn-ps-x hn-ps-bezel', viewBox: '0 0 380 380', 'aria-hidden': 'true' });
    svg('circle', { cx: C, cy: C, r: 187, fill: 'none', stroke: '#B8923A', 'stroke-width': 1.6 }, bezel);
    svg('circle', { cx: C, cy: C, r: 170, fill: 'none', stroke: '#C9A24A', 'stroke-width': 1 }, bezel);
    for (let i = 0; i < 72; i++) {
      const long = i % 6 === 0, [x1, y1] = pt(R_TICK - (long ? 4 : 1.5), i * 5), [x2, y2] = pt(R_TICK + (long ? 5 : 2.5), i * 5);
      svg('line', { x1, y1, x2, y2, stroke: '#B8923A', 'stroke-width': long ? 1.4 : .8, 'stroke-linecap': 'round', opacity: long ? .9 : .55 }, bezel);
    }
    dial.insertBefore(bezel, list);

    const band = svg('svg', { class: 'hn-ps-x hn-ps-band', viewBox: '0 0 380 380', 'aria-hidden': 'true' });
    const segs = [], labs = [];
    names.forEach((n, i) => {
      const a = homeAngle(i), a1 = a - step / 2, a2 = a + step / 2, big = step > 180 ? 1 : 0;
      const [ox1, oy1] = pt(R_OUT, a1), [ox2, oy2] = pt(R_OUT, a2), [ix2, iy2] = pt(R_IN, a2), [ix1, iy1] = pt(R_IN, a1);
      segs.push(svg('path', { class: 'hn-ps-seg', fill: i % 2 ? '#EFE4CC' : '#F8F0DE',
        d: `M ${ox1} ${oy1} A ${R_OUT} ${R_OUT} 0 ${big} 1 ${ox2} ${oy2} L ${ix2} ${iy2} A ${R_IN} ${R_IN} 0 ${big} 0 ${ix1} ${iy1} Z` }, band));
    });
    for (let i = 0; i < N; i++) {
      const a = homeAngle(i) + step / 2, [x1, y1] = pt(R_IN, a), [x2, y2] = pt(R_OUT, a);
      svg('line', { x1, y1, x2, y2, stroke: '#C9A24A', 'stroke-width': 1, opacity: .85 }, band);
    }
    svg('circle', { cx: C, cy: C, r: R_OUT, fill: 'none', stroke: '#C9A24A', 'stroke-width': 1.2 }, band);
    svg('circle', { cx: C, cy: C, r: R_IN, fill: 'none', stroke: '#C9A24A', 'stroke-width': 1.2 }, band);
    const labLayer = svg('g', {}, band);
    list.appendChild(band);

    // Prize names written along the circle, letter by letter (works the same in every browser).
    // Each name has an "up" copy (reads right when it is at the top) and a "down" copy (for the bottom half).
    let ctx = null;
    function drawLabels() {
      while (labLayer.firstChild) labLayer.removeChild(labLayer.firstChild);
      labs.length = 0;
      ctx = ctx || document.createElement('canvas').getContext('2d');
      const family = getComputedStyle(host).getPropertyValue('--font-body-family').trim() || 'Poppins, sans-serif';
      names.forEach((n, i) => {
        let text = n.toUpperCase(); const full = text, maxArc = (step - 7) * Math.PI / 180 * R_LAB;
        let size = 11.5, track = 1.2, w;
        const measure = () => {
          ctx.font = `600 ${size}px ${family}`;
          const ws = Array.prototype.map.call(text, ch => ctx.measureText(ch).width);
          return { ws, total: ws.reduce((s, x) => s + x, 0) + track * (text.length - 1) };
        };
        w = measure();
        if (w.total > maxArc) { size = Math.max(7.5, size * maxArc / w.total); track = Math.max(.3, track * maxArc / w.total); w = measure(); }
        // still too long at the smallest size (a very long prize name): shorten it with "..." so it stays in its own slice
        while (w.total > maxArc && text.length > 4) { text = full.slice(0, text.replace(/…$/, '').length - 1).trimEnd() + '…'; w = measure(); }
        const a = homeAngle(i), g = { up: svg('g', { class: 'hn-ps-lab' }, labLayer), down: svg('g', { class: 'hn-ps-lab' }, labLayer) };
        ['up', 'down'].forEach(way => {
          const dir = way === 'up' ? 1 : -1;
          let x = -w.total / 2;
          Array.prototype.forEach.call(text, (ch, k) => {
            const mid = x + w.ws[k] / 2, deg = a + dir * (mid / R_LAB) * 180 / Math.PI, [px, py] = pt(R_LAB, deg);
            x += w.ws[k] + track;
            if (ch === ' ') return;
            const t = svg('text', { x: px.toFixed(2), y: py.toFixed(2), 'text-anchor': 'middle', 'dominant-baseline': 'central',
              transform: `rotate(${(deg + (way === 'up' ? 0 : 180)).toFixed(2)} ${px.toFixed(2)} ${py.toFixed(2)})`,
              'font-size': size.toFixed(2), 'font-family': family }, g[way]);
            t.textContent = ch;
          });
        });
        labs.push(g);
      });
      orient();
    }
    // show the copy that reads right side up where each name is now
    function orient() {
      const turn = angleOf(list) - 90;
      labs.forEach((g, i) => {
        const up = Math.cos((homeAngle(i) + turn) * Math.PI / 180) >= -0.01;
        g.up.style.display = up ? '' : 'none';
        g.down.style.display = up ? 'none' : '';
      });
    }

    // medallion: PopSpin's own logo disc, dressed as gold with a white face; plus our sheen, flare, comet, pointer
    const logo = medal.querySelector('img');
    if (logo && LOGO_URL) {
      const old = logo.src;
      logo.addEventListener('error', function back() { logo.removeEventListener('error', back); logo.src = old; });
      logo.src = LOGO_URL; logo.alt = 'Haye Nii';
    }
    const sheen = div('hn-ps-x hn-ps-sheen', medal);
    const comet = div('hn-ps-x hn-ps-comet');
    dial.insertBefore(comet, medal);
    const flare = div('hn-ps-x hn-ps-flare', dial);
    const pointer = div('hn-ps-x hn-ps-pointer', dial);
    const sparks = div('hn-ps-x hn-ps-sparks', dial);
    pointer.setAttribute('aria-hidden', 'true');

    // at rest the pointer sits on the line BETWEEN two prizes, never on one (resting on the Mystery Gift looked
    // rigged). PopSpin aims each spin at an exact angle for its prize, wherever the wheel starts, so the landing
    // does not change. Not touched if PopSpin already placed the wheel (e.g. showing an earlier win).
    if (!list.style.transform) list.style.transform = `rotate(${180 + step / 2}deg)`;

    function spark(x, y, dx, dy, ms, s0) {
      const s = div('hn-ps-spark', sparks), k = dial.offsetWidth / 380;
      s.style.left = (x / 3.8) + '%'; s.style.top = (y / 3.8) + '%';
      anim(ms, t => {
        const e = easeOut(t);
        s.style.opacity = String(1 - t);
        s.style.transform = `translate(-50%, -50%) translate(${(dx * e * k).toFixed(1)}px, ${(dy * e * k).toFixed(1)}px) scale(${(s0 - (s0 - .2) * t).toFixed(2)})`;
      }, () => s.remove());
    }

    // ---- follow PopSpin's spin: it sets a CSS transition on its wheel, then "none" when it stops
    let spinning = false, raf = 0, spinSafety = 0;
    function spinStart(ms) {
      spinning = true;
      host.classList.add('hn-ps-spinning');
      // phone: close the keyboard and bring the dial back into view so the shopper sees the spin
      const typed = root.activeElement;
      if (typed && typed.tagName === 'INPUT') typed.blur();
      if (card.scrollTop) card.scrollTo({ top: 0, behavior: calm() ? 'auto' : 'smooth' });
      // keep the card the same height when the words change, so it doesn't jump at the reveal
      card.style.minHeight = card.offsetHeight + 'px';
      dial.classList.remove('hn-ps-won');
      segs.forEach(s => s.classList.remove('is-win')); labs.forEach(g => { g.up.classList.remove('is-win'); g.down.classList.remove('is-win'); });
      clearTimeout(spinSafety);
      spinSafety = setTimeout(() => { if (spinning) spinEnd(); }, ms + 1500); // never get stuck "spinning"
      cancelAnimationFrame(raf);
      if (calm()) return;
      anim(900, t => {
        flare.style.opacity = String(t < .25 ? t / .25 : 1 - (t - .25) / .75);
        flare.style.transform = `translate(-50%, -50%) scale(${(.3 + 1.6 * easeOut(t)).toFixed(3)})`;
      });
      let last = angleOf(list), total = 0, t0 = performance.now(), acc = 0, prev = t0;
      (function fr(now) {
        if (!spinning) return;
        const a = angleOf(list); let d = a - last; if (d > 180) d -= 360; if (d < -180) d += 360; total += d; last = a;
        const p = Math.min(1, (now - t0) / ms), head = a - 90 + 18 + total * .08;
        comet.style.transform = `translate(-50%, -50%) rotate(${head.toFixed(1)}deg)`;
        comet.style.opacity = String(p < .08 ? p / .08 : p > .78 ? Math.max(0, 1 - (p - .78) / .2) : 1);
        acc += now - prev; prev = now;
        while (p < .82 && acc > 40) {
          acc -= 40;
          const [x, y] = pt(R_IN + 8 + Math.random() * (R_OUT - R_IN - 16), head - 4 - Math.random() * 26);
          spark(x, y, Math.random() * 16 - 8, Math.random() * 16 - 8, 600 + Math.random() * 500, 1);
        }
        raf = requestAnimationFrame(fr);
      })(t0);
    }
    function spinEnd() {
      spinning = false;
      clearTimeout(spinSafety);
      cancelAnimationFrame(raf);
      host.classList.remove('hn-ps-spinning');
      comet.style.opacity = '0';
      markWinner(true);
      if (calm()) return;
      anim(1300, t => sheen.style.setProperty('--sx', (-120 + 240 * easeOut(t)).toFixed(1) + '%'));
      for (let i = 0; i < 26; i++) {
        const a = Math.random() * Math.PI * 2, d = 90 + Math.random() * 90;
        spark(C, C, Math.cos(a) * d, Math.sin(a) * d, 900 + Math.random() * 500, 1.4);
      }
    }
    function markWinner(fresh) {
      orient();
      const turn = angleOf(list) - 90;
      let win = 0, best = 999;
      names.forEach((n, i) => { const d = near(homeAngle(i) + turn); if (d < best) { best = d; win = i; } });
      segs.forEach((s, i) => s.classList.toggle('is-win', i === win));
      labs.forEach((g, i) => { g.up.classList.toggle('is-win', i === win); g.down.classList.toggle('is-win', i === win); });
      dial.classList.add('hn-ps-won');
      if (fresh) dial.classList.add('hn-ps-won-now');
    }
    new MutationObserver(() => {
      const tr = list.style.transition || '';
      const m = /transform\s+(\d+)ms/.exec(tr);
      if (m && +m[1] >= 400 && !spinning) spinStart(+m[1]);
      else if (tr === 'none' && spinning) spinEnd();
      else if (!spinning) orient();
    }).observe(list, { attributes: true, attributeFilter: ['style'] });

    // ---- the "unlocked" screen: our heading over PopSpin's result (PopSpin still shows the code and buttons)
    const head = success.querySelector('.ca-sw-modal-content--text__header');
    const win = div('hn-ps-x hn-ps-win');
    const winTitle = document.createElement('h2'); winTitle.className = 'hn-ps-win__title';
    const winSub = document.createElement('p'); winSub.className = 'hn-ps-win__sub';
    win.appendChild(winTitle); win.appendChild(winSub);
    if (head) head.appendChild(win);
    const cont = success.querySelector('.ca-sw-continue-shopping-btn');
    function fillResult() {
      const r = host.reward || null;
      if (!r || r.type === 'none') return;
      const prize = String(r.title || '').trim() || 'welcome gift';
      const who = store.get('hn_ps_name') || '';
      winTitle.textContent = '';
      winTitle.appendChild(document.createTextNode(who ? who + ', your ' : 'Your '));
      const em = document.createElement('em'); em.textContent = prize; winTitle.appendChild(em);
      winTitle.appendChild(document.createTextNode(' is unlocked'));
      const popText = head && head.querySelector('.ca-sw-modal-text');
      let line = '';
      if (r.code) line = 'Use this code at checkout.';
      else if (r.emailSent) line = '';
      // no code (the Mystery Gift): PopSpin's text says "copy your discount code", but there is none
      else if (/mystery\s*gift/i.test(prize)) line = 'Claim your free Mystery Gift at checkout.';
      else {
        line = popText ? popText.textContent.trim() : '';
        if (/code/i.test(line)) line = 'Claim it at checkout.';
      }
      winSub.textContent = line;
      winSub.style.display = line ? '' : 'none';
      success.classList.toggle('hn-ps-has-code', !!r.code);
      if (cont && !r.code) cont.textContent = 'Shop now';
      markWinner(false);
      fit();
    }
    new MutationObserver(() => { if (visible(result) && visible(success)) fillResult(); })
      .observe(result, { attributes: true, subtree: true, attributeFilter: ['hidden', 'style'] });

    // ---- size: the whole popup fits one screen, any phone, no scrolling
    let fitW = 0;
    function fit() {
      if (!host.classList.contains('hn-ps')) return;
      const vw = window.innerWidth, vh = window.innerHeight;
      // after the reveal the words are shorter: keep the dial the same size (no jump), unless the screen changed
      if (visible(result) && fitW === vw && host.style.getPropertyValue('--hn-d')) return;
      fitW = vw;
      let d;
      if (isPhone()) {
        const panel = visible(result) ? result : intro;
        const chrome = 52; // sheet padding above + below the dial
        d = Math.min(vw - 72, vh - panel.offsetHeight - chrome - 24, 300);
      } else {
        const half = Math.min(880, vw - 32) * .5, st = getComputedStyle(stage);
        d = Math.min(372, half - 48, vh - 2 * (parseFloat(getComputedStyle(overlay).paddingTop) || 16) - parseFloat(st.paddingTop) - parseFloat(st.paddingBottom));
      }
      host.style.setProperty('--hn-d', Math.round(Math.max(150, d)) + 'px');
    }
    let lastW = window.innerWidth;
    window.addEventListener('resize', () => {
      // a phone keyboard opening only makes the screen shorter: keep the dial still while typing
      const typing = root.activeElement && /^(INPUT)$/.test(root.activeElement.tagName);
      if (typing && window.innerWidth === lastW) return;
      lastW = window.innerWidth; fit();
    });

    // ---- phone keyboard (iPhone): the keyboard covers the bottom of the screen but the page does not get shorter,
    // so a sheet stuck to the bottom hides the field being typed in. On phones the popup follows the part of the
    // screen that is really visible (visualViewport), the card scrolls inside, and the field is kept in view.
    function keepFieldInView() {
      const el = root.activeElement;
      if (!el || el.tagName !== 'INPUT' || !visible(overlay)) return;
      const c = card.getBoundingClientRect(), r = el.getBoundingClientRect(), pad = 14;
      if (c.height < 60) return;
      // show the field and, if there is room, the button under it too
      const b = btn && btn.getBoundingClientRect();
      const want = b && b.bottom - r.top <= c.height - 2 * pad ? b.bottom : r.bottom;
      if (want > c.bottom - pad) card.scrollTop += want - (c.bottom - pad);
      else if (r.top < c.top + pad) card.scrollTop -= (c.top + pad) - r.top;
    }
    let vvTimer = 0;
    function followScreen() {
      const vv = window.visualViewport;
      const on = !!vv && (isPhone() || touch()) && host.classList.contains('hn-ps') && overlay.classList.contains('visible');
      host.classList.toggle('hn-ps-vv', on);
      if (!on) return;
      host.style.setProperty('--hn-vv-top', Math.max(0, vv.offsetTop).toFixed(1) + 'px');
      host.style.setProperty('--hn-vv-h', vv.height.toFixed(1) + 'px');
      clearTimeout(vvTimer);
      vvTimer = setTimeout(keepFieldInView, 60);
    }
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', followScreen);
      window.visualViewport.addEventListener('scroll', followScreen);
    }
    // the keyboard slides up over ~0.3 s: check again while it moves
    root.addEventListener('focusin', e => {
      if (!e.target || e.target.tagName !== 'INPUT') return;
      followScreen(); setTimeout(followScreen, 150); setTimeout(followScreen, 400);
    });

    // ---- open / close: refit, hide the chat bubble that covers the popup on phones, draw the labels once
    let drawn = false, mine = false;
    function onOpen() {
      const open = overlay.classList.contains('visible');
      mine = open && host.classList.contains('hn-ps');
      markOpen(host, mine);
      followScreen();
      if (!open) return;
      fit();
      if (!drawn) {
        drawn = true;
        drawLabels();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawLabels);
      }
      if (visible(result) && visible(success)) fillResult();
    }
    new MutationObserver(onOpen).observe(overlay, { attributes: true, attributeFilter: ['class'] });
    // belt and braces: never leave the chat bubble hidden after the popup is gone
    const watch = setInterval(() => {
      if (mine && !(overlay.isConnected && overlay.classList.contains('visible'))) {
        mine = false;
        markOpen(host, false);
      }
      if (!host.isConnected && !mine) clearInterval(watch);
    }, 1000);
    if (closeBtn) closeBtn.setAttribute('aria-label', 'Close');
    onOpen();
  }

  // ---- reminder pill after a win, on EVERY page (owner 2026-10-15). PopSpin's own bar never showed for the
  // Mystery Gift (no code, no end time: PopSpin starts its timer only for prizes with an end time) and it only
  // exists on pages where PopSpin's popup is allowed. This pill is built only from what PopSpin itself saved after
  // a win: popSpinReward (the prize + code), popSpinStartTime (set at a win, removed when the bar is closed) and
  // popSpinEndTime (PopSpin's real deadline, if the prize has one). PopSpin's bar is hidden while this runs.
  const PILL_CLOSED = 'hn_ps_pill_closed';
  const ATC = 'button[name="add"], .product-form__submit, [name="checkout"], #checkout, .cart__checkout-button, .shopify-payment-button__button';
  let pill = null, pillWin = null;
  function readWin() {
    let r = null;
    try { const j = JSON.parse(localStorage.getItem('popSpinReward') || 'null'); r = j && j.reward; } catch (e) {}
    if (!r || typeof r !== 'object' || r.type === 'none' || !store.get('popSpinStartTime')) return null;
    const title = String(r.title || '').replace(/\s+/g, ' ').trim(), code = String(r.code || '').trim();
    if (!title && !code) return null;
    let end = parseInt(store.get('popSpinEndTime') || '', 10);
    if (!Number.isFinite(end) && r.expirationDate) end = new Date(r.expirationDate).getTime();
    if (!Number.isFinite(end)) {
      // a prize that should end but has no deadline saved any more = PopSpin already ended it: no pill
      if (r.expiration && r.expiration !== 'never') return null;
      end = 0;
    }
    if (end && end <= Date.now()) return null;
    const id = title + '|' + code;
    if (store.get(PILL_CLOSED) === id) return null;
    return { title, code, end, id };
  }
  const howLong = ms => {
    const s = Math.max(0, Math.floor(ms / 1000)), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    if (d >= 1) return d + (d === 1 ? ' day' : ' days');
    const two = n => String(n).padStart(2, '0');
    return (h ? h + ':' + two(m) : m) + ':' + two(x);
  };
  const el = (tag, cls, parent, text) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    if (parent) parent.appendChild(e);
    return e;
  };
  function buildPill(w) {
    const p = el('div', w.code ? 'hn-ps-pill hn-ps-pill--code' : 'hn-ps-pill');
    p.setAttribute('role', 'region');
    p.setAttribute('aria-label', 'Your welcome gift');
    el('span', 'hn-ps-pill__dot', p).setAttribute('aria-hidden', 'true');
    const txt = el('span', 'hn-ps-pill__txt', p);
    el('strong', 'hn-ps-pill__title', txt, w.code ? w.title || 'Your welcome offer' : (w.title || 'Your gift') + ' unlocked');
    const sub = el('span', 'hn-ps-pill__sub', txt);
    p.__say = el('span', '', sub);
    p.__time = el('span', 'hn-ps-pill__time', sub);
    if (w.code) {
      const c = el('button', 'hn-ps-pill__code', p);
      c.type = 'button';
      c.setAttribute('aria-label', 'Copy code ' + w.code);
      el('span', '', c, w.code);
      const cl = el('span', 'hn-ps-pill__copy', c, 'Copy');
      c.addEventListener('click', () => {
        const done = () => { cl.textContent = 'Copied'; setTimeout(() => { cl.textContent = 'Copy'; }, 2000); };
        const old = () => {
          const a = el('textarea', '', document.body); a.value = w.code; a.setAttribute('readonly', '');
          a.style.cssText = 'position:fixed;top:0;left:0;opacity:0'; a.select();
          try { if (document.execCommand('copy')) done(); } catch (e) {}
          a.remove();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(w.code).then(done, old); else old();
      });
    }
    const x = el('button', 'hn-ps-pill__x', p);
    x.type = 'button'; x.setAttribute('aria-label', 'Close');
    x.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    x.addEventListener('click', () => {
      // the same as closing PopSpin's own bar, and this prize's pill stays closed
      store.set(PILL_CLOSED, w.id);
      try { localStorage.removeItem('popSpinStartTime'); localStorage.removeItem('popSpinEndTime'); } catch (e) {}
      const bar = document.getElementById('ca-sw-discount-expiration-countdown');
      if (bar) bar.style.display = 'none';
      removePill();
    });
    return p;
  }
  function removePill() { if (pill) pill.remove(); pill = null; pillWin = null; }
  // where the pill sits: never over the phone "Add to cart" bar, the chat bubble or an Add to cart / Check out button
  function placePill() {
    if (!pill) return;
    const bar = document.documentElement.classList.contains('hn-sticky-atc-on') && document.querySelector('.hn-sticky-atc');
    let lift = bar && bar.offsetHeight ? bar.offsetHeight : 0, maxW = '';
    if (window.innerWidth < 750) {
      // phones: the chat bubble sits bottom-right (lifted above the Add to cart bar when that shows):
      // stay left of it, or above it when there is not enough room beside it (small phones)
      const host = document.getElementById('smart-bot-container');
      const icon = host && host.shadowRoot && host.shadowRoot.querySelector('[class*="chat-icon-container"]');
      const b = icon && icon.getBoundingClientRect();
      // the bubble's real size (it grows in from small when the page opens)
      const bw = icon && icon.offsetWidth || 0, bh = icon && icon.offsetHeight || 0;
      const r = b && bw ? { left: b.left + b.width / 2 - bw / 2, top: b.top + b.height / 2 - bh / 2 } : null;
      const bubble = !!r && r.top < window.innerHeight;
      const room = bubble ? r.left - 12 - 10 : window.innerWidth - 24;
      pill.style.maxWidth = 'none';
      const need = Math.min(pill.scrollWidth, window.innerWidth - 24);
      if (bubble && need > room) lift = Math.max(lift, window.innerHeight - r.top - 16 + 10);
      else maxW = Math.max(150, room) + 'px';
    }
    pill.style.setProperty('--hn-pill-lift', lift + 'px');
    pill.style.maxWidth = maxW;
    // fade away while it would cover an Add to cart / Check out button on the page
    const pr = pill.getBoundingClientRect();
    let away = false;
    document.querySelectorAll(ATC).forEach(b => {
      if (away || !b.offsetParent) return;
      const r = b.getBoundingClientRect();
      if (r.width && r.right > pr.left && r.left < pr.right && r.bottom > pr.top - 6 && r.top < pr.bottom + 6) away = true;
    });
    pill.classList.toggle('is-away', away);
  }
  function syncPill() {
    const w = readWin();
    if (!w) { removePill(); return; }
    const fresh = !pill || pillWin.id !== w.id;
    if (fresh) {
      removePill();
      pill = buildPill(w); pillWin = w;
      document.body.appendChild(pill);
    }
    // code: "Ends in 29:41" (the time matters most, it comes first); no code: "Claim it at checkout · 29:41 left"
    const t = w.end ? howLong(w.end - Date.now()) : '';
    const say = w.code ? (t ? 'Ends in ' : 'Use at checkout') : 'Claim it at checkout' + (t ? ' · ' : '');
    const time = t && !w.code ? t + ' left' : t;
    if (pill.__say.textContent !== say) pill.__say.textContent = say;
    if (pill.__time.textContent !== time) pill.__time.textContent = time;
    if (fresh) {
      placePill(); // measures the full pill, so the browser has its start look and the next line fades it in
      pill.classList.add('is-in');
    }
  }
  function startPill() {
    document.documentElement.classList.add('hn-ps-pill-on'); // hides PopSpin's own bar: this pill replaces it
    syncPill();
    setInterval(() => { if (!document.hidden) { syncPill(); placePill(); } }, 1000);
    let queued = false;
    const soon = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; placePill(); }); };
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    window.addEventListener('storage', syncPill);
    window.addEventListener('pageshow', syncPill);
    // the phone Add to cart bar coming and going moves the chat bubble too (0.35 s): place again after it
    new MutationObserver(() => { soon(); setTimeout(placePill, 420); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.body) startPill(); else document.addEventListener('DOMContentLoaded', startPill);

  function scan() {
    document.querySelectorAll('spin-wheel-popup').forEach(dress);
  }
  customElements.whenDefined('spin-wheel-popup').then(() => {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true });
  });
})();
